import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL + "/MGA";

export const getMGAList = () => {
  return axios.get(`${api_base_url}`).then((res) => {
    return res.data;
  });
};

//Add MGA
export const addMGA = async (newData) => {
  return await axios.post(`${api_base_url}`, newData[0]);
};

//Delete MGA
export const deleteMGA = async (ids) => {
  await axios.delete(`${api_base_url}/MGA`, {
    data: ids,
  });
};

//Update MGA
export const updateMGA = async (updatedMGA) => {
  return await axios.put(`${api_base_url}`, {
    ...updatedMGA,
  });
};
